import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import style from './style.module.css';
import GpAddressExplainer from 'pages/tooltip/gp-address-explainer';
import EstimatedTotalExplainer from 'pages/tooltip/estimated-total-explainer';
import { BackPage } from 'components';

const Tooltips = [
  {
    id: '1',
    component: GpAddressExplainer,
  },
  {
    id: '2',
    component: EstimatedTotalExplainer,
  },
];

const Tooltip = () => {
  const history = useHistory();
  const { id } = useParams();
  const tooltip = Tooltips.find((tip) => tip.id === id);

  if (!tooltip) history.goBack();

  return (
    <BackPage onBackClick={() => history.goBack()} bplg="7">
      <div className={`coop-l-container genericSpacer ${style.tooltipOuter}`}>
        <div className={`${style.tooltipContainer} coop-l-medium-8 coop-l-large-6`}>{<tooltip.component />}</div>
      </div>
    </BackPage>
  );
};

export default Tooltip;
